import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_Branching = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Branching Statements in C"
    videos={[
      "https://www.youtube.com/embed/i4Dr0QuhPsQ", // if statement in C
      "https://www.youtube.com/embed/SdYWiM7i8v4", // nested if statement
      "https://www.youtube.com/embed/2STObWfRm5k", // if else if ladder
      "https://www.youtube.com/embed/d-Y4CmyrAuA", // switch statement
      "https://www.youtube.com/embed/3w81X4yg6Yk", // goto statement
    ]}
    takeaways={[
      { text: "Remember all the flowcharts for if, if-else ladder, nested if, switch, and goto statements." },
      { text: "Understand the flow of execution for different branching statements." },
      { text: "Cascaded if-else means using if, else if, and else statements evaluated sequentially." },
      { text: "In switch statements, questions may involve implementing specific conditions (these are usually easier)." },
    ]}
    questions={[
      "Explain any branching statement with its flowchart.",
      "They may provide some code and ask the output based on flow of execution.",
      "Implement a switch case based on given conditions.",
      "Describe cascaded if-else with an example.",
    ]}
    exampleVideos={[]} // Add example videos if any
  />
);
}

export default OOPS_M1_Branching;
